// extracted by mini-css-extract-plugin
export default {"companyContainer":"JQ-z","companyImage":"KQ-z","container":"LQ-z","heading":"MQ-z","darkText":"NQ-z","smallHeading":"OQ-z","darkBackground":"PQ-z","whiteBackground":"QQ-z"};